import { useEffect, EventHandler } from 'react'
import { checkDotNet, getHost } from './utilities'

/**
 * Listen for a CustomEvent. 
 * If web it uses document, if panel it uses webview
 * @param eventName Name of the CustomEvent
 * @param handler Handler to trigger
 */
export const useCustomEvent = (
  eventName: 'onGeometryChanged' | 'onModelChanged' | 'onResultChanged' | 'onDocumentChanged', 
  handler: EventHandler<any>) => {
  const host: string = getHost()
  
  useEffect(() => {
    if (!checkDotNet()) return
    // If web use document
    let owner = document
    // If panel use webview
    if (host !== 'web') {
      owner = window.parent.chrome.webview
    }
    owner.addEventListener(eventName, handler)

    return () => {
      owner.removeEventListener(eventName, handler)
    }
  }, [])
}
